import { React, useState } from "react";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import databaseIcon from "../../../../../images/database-icon.svg";
import Pagination from "@material-ui/lab/Pagination";
import PrimaryButton from "../../../../../components/PrimaryButton";
import { Link } from "react-router-dom";
import GridTable from "../../../../../components/GridTable";

const useStyles = makeStyles((theme) => ({
  searchBar: {
    width: "70%",
    backgroundColor: "white",
    marginLeft: "3%",
    marginTop: "2%",
  },
  formControl: {
    margin: theme.spacing(1),
    marginLeft: "3%",
    marginTop: "2%",
    minWidth: 120,
    backgroundColor: "white",
    width: "15%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  gridRoot: {
    flexGrow: 1,
  },
  gridContainer: {
    width: "90%",
    marginLeft: "3%",
    marginTop: "3%",
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: "left",
    padding: "10%",
    color: theme.palette.text.secondary,
    height: "30vh",
    fontWeight: "400",
    fontSize: "0.9rem",
  },
  methodName: {
    marginLeft: 10,
  },
  myButton: {
    float: "right",
    marginRight: "8%",
    marginTop: "2%",
  },
  dbInfo: {
    marginTop: "10%",
    maxHeight: "60%",
    overflow: "scroll",
  },
}));

const PublicDatasets = (props) => {
  const classes = useStyles();
  const [sort, setSort] = useState("");
  const [selectedDB, setSelectedDB] = useState(0);
  const handleChange = (event) => {
    setSort(event.target.value);
  };

  return (
    <>
      <TextField
        id="outlined-basic"
        label="Search databases..."
        variant="outlined"
        className={classes.searchBar}
      />
      <FormControl variant="outlined" className={classes.formControl}>
        <InputLabel id="demo-simple-select-outlined-label">
          Choose a field
        </InputLabel>
        <Select
          labelId="demo-simple-select-outlined-label"
          id="demo-simple-select-outlined"
          value={sort}
          onChange={handleChange}
          label="Sort By"
        >
          <MenuItem value={10}>Date</MenuItem>
          <MenuItem value={20}>Alphabetical</MenuItem>
          <MenuItem value={30}>Usage</MenuItem>
        </Select>
      </FormControl>

      <div className={classes.gridRoot}>
        <Grid container spacing={5} className={classes.gridContainer}>
          <Grid item xs={4}>
            <Paper
              onClick={() => {
                setSelectedDB(1);
                props.onSelect("The Cancer Genome Atlas");
              }}
              className={classes.paper}
              elevation={0}
              style={{
                border: `${selectedDB === 1 ? "2px solid #FF7E67" : "none"}`,
              }}
            >
              <GridTable
                tableContent={[
                  {
                    key: <img src={databaseIcon} alt="method-icon" />,
                    value: "The Cancer Genome Atlas",
                  },
                ]}
                keySize={2}
                valueSize={9}
              />
              <div className={classes.dbInfo}>
                The Cancer Genome Atlas (TCGA), a landmark cancer genomics
                program, molecularly characterized over 20,000 primary cancer
                and matched normal samples spanning 33 cancer types.
              </div>
            </Paper>
          </Grid>
          <Grid item xs={4}>
            <Paper
              onClick={() => {
                setSelectedDB(2);
                props.onSelect("ENCODE");
              }}
              className={classes.paper}
              elevation={0}
              style={{
                border: `${selectedDB === 2 ? "2px solid #FF7E67" : "none"}`,
              }}
            >
              <GridTable
                tableContent={[
                  {
                    key: <img src={databaseIcon} alt="method-icon" />,
                    value: "ENCODE",
                  },
                ]}
                keySize={2}
                valueSize={9}
              />
              <div className={classes.dbInfo}>
                The goal of ENCODE is to build a comprehensive parts list of
                functional elements in the human genome, including elements that
                act at the protein and RNA levels, and regulatory elements that
                control cells and circumstances in which a gene is active.
              </div>
            </Paper>
          </Grid>
          <Grid item xs={4}>
            <Paper
              onClick={() => {
                setSelectedDB(3);
                props.onSelect("Human Tumor Atlas Network");
              }}
              className={classes.paper}
              elevation={0}
              style={{
                border: `${selectedDB === 3 ? "2px solid #FF7E67" : "none"}`,
              }}
            >
              <GridTable
                tableContent={[
                  {
                    key: <img src={databaseIcon} alt="method-icon" />,
                    value: "Human Tumor Atlas Network",
                  },
                ]}
                keySize={2}
                valueSize={9}
              />
              <div className={classes.dbInfo}>
                An NCI-funded Cancer Moonshot initiative to construct
                3-dimensional atlases of the dynamic cellular, morphological,
                and molecular features of human cancers as they evolve from
                precancerous lesions to advanced disease.
              </div>
            </Paper>
          </Grid>
          <Pagination count={10} />
        </Grid>
      </div>
      <Link to="/methods/new-method/search">
        <PrimaryButton
          isDisabled={!selectedDB}
          innerText="Next"
          styleClasses={classes.myButton}
        />
      </Link>
    </>
  );
};

export default PublicDatasets;
